import { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import { useSelector } from 'react-redux'
import { AutoSizer } from 'react-virtualized'
import { MainLayout, ExchangesFilterLayout } from 'src/layouts'
import { NewsFeed } from 'src/components/NewsFeed'
import { Loader } from 'src/components/Loader'
import { FooterMobile } from 'src/components/FooterMobile'
import { ShareMapHeader } from 'src/components/ShareMapHeader'
import {
  getFilteredExchangesDataTree,
  getCurrentCurrencySelector,
  getFullScreenState,
  getExchangesDependsOn,
  getExchangesActivePeriod,
  getCoinsExceptions,
  getExchangesGroup,
} from 'src/redux/selectors'
import { TREEMAP_ID, ENTITY, PERIODS } from 'src/consts'
import useWidth from 'src/hooks/useWidth'
import useFetchMapData from 'src/hooks/useFetchMapData'
import styles from './styles.module.scss'
import { useRouter } from 'next/router'
import { intl } from 'src/i18n'

const TreeMap = dynamic(() => import('src/components/TreeMap'), {
  ssr: false,
})

const title = intl.t('exchange.seo.title')
const description = intl.t('exchange.seo.description')

const uri = '/exchange'

const Exchange = () => {
  const router = useRouter()
  const activePeriod = useSelector(getExchangesActivePeriod)
  const dataType = PERIODS.dataKeys[activePeriod]
  const currency = useSelector(state => getCurrentCurrencySelector(state))
  const [isLoading, setIsLoading] = useState(true)
  const fullScreen = useSelector(getFullScreenState)
  const { isMobile } = useWidth()
  const isShare = router.asPath.includes('getScreen')

  useEffect(() => {
    setIsLoading(false)
  }, [])

  useFetchMapData({ entity: ENTITY.EXCHANGE })

  const viewProps = {
    id: TREEMAP_ID,
    isMobile,
    widget: undefined,
    topLeaderboardHeight: undefined,
    currency,
    dataType,
    autoUpdate: false,
    baseValue: useSelector(getExchangesDependsOn),
    activePeriod,
    filteredTree: useSelector(getFilteredExchangesDataTree),
    exceptions: useSelector(getCoinsExceptions),
    entity: ENTITY.EXCHANGE,
    groupFilter: useSelector(getExchangesGroup),
  }

  return (
    <MainLayout title={title} description={description} uri={uri} isHeatmap>
      {/* Changed !fullScreen && !isMobile && !isShare && to !fullScreen && !isShare && for now so we can show the filter in mobile 29/2  */}
      {!fullScreen && !isShare && (
        <ExchangesFilterLayout classNames={[styles.filters]} />
      )}
      {isShare && <ShareMapHeader />}
      <h1 className={styles.seotags}>
        Interactive Heatmap: Visualizing the Trading Volumes of Crypto Exchanges
      </h1>
      <h2 className={styles.seotags}>
        Discover Top Cryptocurrency Exchanges by Trading Volume
      </h2>
      <h2 className={styles.seotags}>
        Navigate the Crypto Exchange Landscape with Our Interactive Heatmap
      </h2>
      <div className={styles.mapbox}>
        <AutoSizer
          defaultWidth={viewProps.isMobile ? 320 : 1280}
          defaultHeight={1024}
        >
          {({ height, width }) => {
            return <TreeMap width={width} height={height} {...viewProps} />
          }}
        </AutoSizer>
      </div>
      <Loader isActive={isLoading} />
      {!isShare && <NewsFeed />}
      {isMobile && !isShare && <FooterMobile />}
    </MainLayout>
  )
}

export default Exchange
